/**
 * Pilot workspaces, gated by LaunchDarkly `theo-pilot`.
 *
 * The client SDK is configured with `useCamelCaseFlagKeys: false`, so the
 * dashboard key arrives as `theo-pilot`. The camelCase key is accepted too,
 * matching the other flag helpers.
 *
 * A missing flag is off: Workflows, Playbooks, Schedules, and Create an Agent
 * stay available until LaunchDarkly turns the pilot on.
 */

export const THEO_PILOT_FLAG = "theo-pilot";
export const THEO_PILOT_UNAVAILABLE_MESSAGE = "Not available in pilot";

/** Sidebar tab ids locked while `theo-pilot` is on. */
export const THEO_PILOT_LOCKED_NAV_IDS = new Set(["workflows", "schedules", "playbooks", "create"]);

export function isTheoPilotEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  return flags[THEO_PILOT_FLAG] === true || flags.theoPilot === true;
}
